module.exports = __webpack_public_path__ + "img/logo2.51a615c1.svg";